import { ConditionalRender } from '@ui';
import { getFileUrl } from '@/api/utils';
import { formatTimestamp } from '@/utils/helpers';

type SignatureRowProps = {
  timestamp?: string;
  timeZone?: string;
  filePath?: string;
  hideTimestamp?: boolean;
};

export const SignatureRow = ({ timestamp, timeZone, filePath, hideTimestamp }: SignatureRowProps) => {
  return (
    <ConditionalRender show={!!timestamp} placeholder="-">
      <div className="flex justify-between items-center">
        {!hideTimestamp && formatTimestamp(timestamp, timeZone)}
        <a className="underline" href={getFileUrl(filePath)} target="_blank" rel="noreferrer">
          Signature
        </a>
      </div>
    </ConditionalRender>
  );
};
